// We import lodash in webpack when compiling but will fail in testing. Better to include it explicitly
import _ from "lodash";
import { OrderedRecord } from "../types/redux-store";

export const getOrderedEntities = <T>(entities: OrderedRecord<T>) => {
  return _.map(_.uniq(entities.allIds), (id) => entities.byId[id]);
};

export const getEntityMap = <T>(
  entities: string[],
  entityIds: Record<string, T>,
  specificIds: string[] | null = null
) => {
  const entityMap: T[] = [];
  if (!entities) {
    return [];
  }
  _.map(entities, (id) => {
    if (
      specificIds === null ||
      (specificIds !== null && specificIds.includes(id))
    ) {
      return entityMap.push(entityIds[id]);
    }
  });
  return entityMap;
};

export const getEntities = (state, entity, specificIds = null) => {
  let entities = [];
  let stateEntities = state.entities[entity];
  if (!stateEntities) {
    return [];
  }
  _.map(stateEntities.allIds, (id) => {
    if (
      specificIds === null ||
      (specificIds !== null && specificIds.includes(id))
    ) {
      return entities.push(stateEntities.byId[id]);
    }
  });
  return entities;
};

export const getEntitiesByPage = (state, entity, page, specificIds = null) => {
  let entities = [];
  let stateEntities = state.entities[entity][page];
  if (!stateEntities) {
    return [];
  }
  _.map(stateEntities.allIds, (id) => {
    const entity = stateEntities.byId[id];
    if (
      entity &&
      (specificIds === null ||
        (specificIds !== null && specificIds.includes(id)))
    ) {
      return entities.push(entity);
    }
  });
  return entities;
};
export const getGenericEntities = (
  state,
  stateEntities,
  specificIds = null
) => {
  let entities = [];
  if (!stateEntities) {
    return [];
  }
  _.map(stateEntities.allIds, (id) => {
    if (
      specificIds === null ||
      (specificIds !== null && specificIds.includes(id))
    ) {
      return entities.push(stateEntities.byId[id]);
    }
  });
  return entities;
};
export const getInboxEntities = (state, entity, specificIds = null) => {
  let entities = [];
  let stateEntities = state.entities.inboxes[entity];
  if (!stateEntities) {
    return [];
  }
  _.map(stateEntities.allIds, (id) => {
    if (
      specificIds === null ||
      (specificIds !== null && specificIds.includes(id))
    ) {
      return entities.push(stateEntities.byId[id]);
    }
  });
  return entities;
};
